import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Autocomplete,
  TextField
} from "@mui/material";
import SoftButton from "components/SoftButton";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import swal from "sweetalert2";
import { api } from "utils/Api";
import { useHierarchy } from "context/HierarchyContext";
import { showError } from "utils/messageAlerts";
import { showWarning } from "utils/messageAlerts";
import { showSuccess } from "utils/messageAlerts";

function ConciergeAddToUnit({ onClose, refreshData }) {
  const [loading, setLoading] = useState(false);
  const [assignedUserEmail, setAssignedUserEmail] = useState("");
  const [property, setProperty] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const { orgId } = useHierarchy();

  useEffect(() => {
    fetchproperty();
  }, []);

  const fetchproperty = async () => {
    try {
      const res = await api.su_Property.getSuProperties(); 
      const propertyData = res.filter(property => property.organization_id === parseInt(orgId));
      setProperty(propertyData || []);
    } catch (e) {
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedProperty) {
      showWarning("Please select a property");
      return;
    }

    if (!assignedUserEmail) {
      showWarning("Please enter a user email");
      return;
    }

    setLoading(true);

    try {
      await api.assign_user_property.assignUserToProperty({
        user_email: assignedUserEmail,
        property_id: selectedProperty.id,
        organization_id: selectedProperty.organization_id,
        user_role_id: 4,
        frontend_metadata: {},
        backend_metadata: {},
      });

      showSuccess("User assigned to property successfully");

      onClose();
      refreshData();
    } catch (error) {      
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
      <form onSubmit={handleSubmit}>
        <DialogTitle>Add User to Property</DialogTitle>

        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

            {/* Searchable Unit */}
            <SoftBox>
              <SoftTypography variant="caption" fontWeight="bold">
                Select Property <Box component="span" color="error.main">*</Box>
              </SoftTypography>

              <Autocomplete
                options={property}
                getOptionLabel={(option) => option.name || ""}
                value={selectedProperty}
                onChange={(event, newValue) => setSelectedProperty(newValue)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search Property..."
                    size="small"
                  />
                )}
              />
            </SoftBox>

            {/* User Email */}
            <SoftBox>
              <SoftTypography variant="caption" fontWeight="bold">
                User Email <Box component="span" color="error.main">*</Box>
              </SoftTypography>

              <SoftInput
                type="email"
                placeholder="Enter user email to assign as Concierge"
                value={assignedUserEmail}
                onChange={(e) => setAssignedUserEmail(e.target.value)}
                required
              />
            </SoftBox>

          </Box>
        </DialogContent>

        <DialogActions>
          <SoftButton onClick={onClose}>Cancel</SoftButton>
          <SoftButton
            variant="gradient"
            color="dark"
            disabled={loading}
            type="submit"
          >
            {loading ? "Saving..." : "Save"}
          </SoftButton>
        </DialogActions>
      </form>
    </Dialog>
  );
}

ConciergeAddToUnit.propTypes = {
  onClose: PropTypes.func.isRequired,
  refreshData: PropTypes.func.isRequired,
};

export default ConciergeAddToUnit;